module.exports = __webpack_public_path__ + "img/sentient.eb154f1c.jpg";